import React from 'react';
import { Restaurant } from '../../types/api';

interface RestaurantSelectProps {
  restaurants: Restaurant[];
  selectedRestaurantId: string | null;
  onSelectRestaurant: (restaurantId: string | null) => void;
  label?: string;
  allowEmpty?: boolean;
}

const RestaurantSelect: React.FC<RestaurantSelectProps> = ({
  restaurants,
  selectedRestaurantId,
  onSelectRestaurant,
  label = 'Ресторан',
  allowEmpty = true,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    onSelectRestaurant(value === '' ? null : value);
  };

  return (
    <div>
      <label htmlFor="restaurant-select" className="block text-sm font-medium text-gray-700" style={{fontFamily: "'Times New Roman', Times, serif"}}>
        {label}
      </label>
      <select
        id="restaurant-select"
        name="restaurant-select"
        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md shadow-sm"
        style={{fontFamily: "'Times New Roman', Times, serif"}}
        value={selectedRestaurantId || ''}
        onChange={handleChange}
      >
        {allowEmpty && <option value="">Выберите ресторан</option>}
        {restaurants.map((restaurant) => (
          <option key={restaurant.restaurant_id} value={restaurant.restaurant_id}>
            {restaurant.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RestaurantSelect;
